import React from 'react';
import { FlexStyledGrid, StyledPagination, StyledText, } from './Pagination.styles';
const extraInfo = (props) => {
    if (props.extraInfo) {
        return (React.createElement(StyledText, { variant: "caption-small" }, props.extraInfo));
    }
};
export const Pagination = (props) => {
    return props.totalNumberOfPages > 1 ? (React.createElement(FlexStyledGrid, { container: true, direction: "column", padding: props.padding },
        React.createElement(StyledPagination, { count: props.totalNumberOfPages, page: props.currentPage, onChange: props.onChange, variant: "outlined", "data-cy": props.dataCy }),
        extraInfo(props))) : null;
};
export default Pagination;
